import React, { createContext, useContext, useState } from "react";

// Estado compartido del "chrome" de la landing: la intro a pantalla completa de Contacto cambia la cabecera
// (SiteHeader) mientras dura. Tres valores:
//   true    → intro con el fondo oscuro en pantalla: enlaces de la cabecera en blanco (`dark` en el diseño).
//   "glass" → revelado (ContactoPage, src/ulture/pages): enlaces ya oscuros; la cápsula sigue de cristal.
//   false   → sin intro (o terminada).
export type ContactIntroState = boolean | "glass";

interface Chrome {
  contactIntroActive: ContactIntroState;
  setContactIntroActive: (v: ContactIntroState) => void;
}

const LandingChromeContext = createContext<Chrome>({
  contactIntroActive: false,
  setContactIntroActive: () => {},
});

export function LandingChromeProvider({ children }: { children: React.ReactNode }) {
  const [contactIntroActive, setContactIntroActive] = useState<ContactIntroState>(false);
  return (
    <LandingChromeContext.Provider value={{ contactIntroActive, setContactIntroActive }}>
      {children}
    </LandingChromeContext.Provider>
  );
}

export const useLandingChrome = () => useContext(LandingChromeContext);
